import { gql } from "@apollo/client";

export const GET_ESTADOS_INDICACION_APROBACION = gql`
    query GetEstadosIndicacionAprobacion {
    estadosIndicacionAprobacion {
      success,
      error,
      valorEsperado {
        idEstadoIndicacionAprobacion,
        descripcion
      }
    }
  }
`;